import { Button } from 'antd'
import { FormattedMessage, useIntl } from 'react-intl'
import { formatCurrency } from 'shared/components/FormattedCurrency/formatCurrency'
import { lang } from './lang'

type Props = {
  onClick: () => void
  amount: number
  currencyCode?: string
}

export default function PayToUploadButton({ onClick, amount, currencyCode }: Props) {
  const intl = useIntl()

  return (
    <Button type="link" onClick={onClick} style={{ padding: '0px' }}>
      <FormattedMessage
        {...lang.payToAddAction}
        values={{
          value: formatCurrency(intl.locale, { value: amount, currency: currencyCode }),
        }}
      />
    </Button>
  )
}
